module.exports = __webpack_public_path__ + "static/media/salad.a00fd643.svg";